//* Library Imports
import { Component } from 'react';
import { connect } from "react-redux";

//* Constants Imports
import { URL } from '../../variables';

//*Services Imports
import { logout } from '../../actions/AppActions';

//* Icons Imports 
import { MdSave, MdSettings } from 'react-icons/md';
import { FaFileAlt, FaAward, FaEdit } from 'react-icons/fa';

//* Components
import CircularProgress from "@material-ui/core/CircularProgress";
import { Form, Button, Alert } from "react-bootstrap";

class FaculdadeConfiguracoes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      saving: false,
      success: false,
      error: "",
      modules: [],
      config: {},
      faculdade_id: props.user?.faculdade_id || props.faculdade_id,
    };
  }

  componentDidMount() {
    this.loadModules();
  }
  loadModules = () => {
    this.setState({ loading: true });
    fetch(`${URL}api/private/faculdades/${this.state.faculdade_id}/modules`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${this.props.token}`,
      },
    })
      .then(async (response) => {
        try {
          let resp = await response.json();
          if (resp.message === "Unauthenticated.") {
            this.props.logout();
            return;
          }
          if (resp.result && resp.data) {
            this.setState({
              modules: resp.data.modules || [],
              loading: false,
            });
          } else {
            this.setState({
              error: "Erro ao carregar módulos",
              loading: false,
            });
          }
        } catch (err) {
          this.setState({
            error: "Erro ao carregar módulos",
            loading: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          error: "Erro ao carregar módulos",
          loading: false,
        });
      });
  };

  handleInputChange = (field, value) => {
    this.setState({
      config: {
        ...this.state.config,
        [field]: value,
      },
    });
  };

  handleModuleToggle = (moduleId, permissionEnabled) => {
    const updatedModules = this.state.modules.map((module) => {
      if (module.id === moduleId) {
        return { ...module, permissionEnabled };
      }
      return module;
    });
    this.setState({ modules: updatedModules });
  };

  handleFeatureToggle = (moduleId, featureId, enabled) => {
    const updatedModules = this.state.modules.map((module) => {
      if (module.id === moduleId) {
        const updatedFeatures = module.features.map((feature) => {
          if (feature.id === featureId) {
            return { ...feature, permissionEnabled: enabled };
          }
          return feature;
        });
        return { ...module, features: updatedFeatures };
      }
      return module;
    });
    this.setState({ modules: updatedModules });
  };

  handleSubFeatureToggle = (moduleId, featureId, subFeatureId, enabled) => {
    const updatedModules = this.state.modules.map((module) => {
      if (module.id === moduleId) {
        const updatedFeatures = module.features.map((feature) => {
          if (feature.id === featureId) {
            const updatedSubFeatures = feature.subFeatures.map((subFeature) => {
              if (subFeature.id === subFeatureId) {
                return { ...subFeature, permissionEnabled: enabled };
              }
              return subFeature;
            });
            return { ...feature, subFeatures: updatedSubFeatures };
          }
          return feature;
        });
        return { ...module, features: updatedFeatures };
      }
      return module;
    });
    this.setState({ modules: updatedModules });
  };

  getIconComponent = (iconName) => {
    const icons = {
      FaFileAlt: FaFileAlt,
      FaAward: FaAward,
      FaEdit: FaEdit,
    };
    const IconComponent = icons[iconName];
    return IconComponent ? <IconComponent /> : <MdSettings />;
  };

  buildPermissionsArray = () => {
    const permissions = [];

    this.state.modules.forEach((module) => {      
      permissions.push({
        module_id: module.id,
        enabled: module.permissionEnabled,
      });

      // Adicionar permissões das features
      if (module.features && module.features.length > 0) {
        module.features.forEach((feature) => {
          permissions.push({
            feature_id: feature.id,
            enabled: feature.permissionEnabled,
          });

          // Adicionar permissões das sub-features
          if (feature.subFeatures && feature.subFeatures.length > 0) {
            feature.subFeatures.forEach((subFeature) => {
              permissions.push({
                sub_feature_id: subFeature.id,
                enabled: subFeature.permissionEnabled,
              });
            });
          }
        });
      }
    });
    return permissions;
  };

  salvarConfiguracoes = () => {
    this.setState({ saving: true, error: "", success: false });

    //* Construir array de permissões
    const permissions = this.buildPermissionsArray();

    //* Salvar permissões dos módulos
    fetch(
      `${URL}api/private/faculdades/${this.state.faculdade_id}/modules/permissions`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${this.props.token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ permissions }),
      }
    )
      .then(async (response) => {
        try {
          const resp = await response.json();

          if (resp.message === "Unauthenticated.") {
            this.props.logout();
            return;
          }
          if (resp.result) {
            const { total_processed, failed_updates } = resp.data;
            if (failed_updates === 0) {
              this.setState({
                success: true,
                saving: false,
              });
              setTimeout(() => {
                this.setState({ success: false });
              }, 3000);
              //! Recarregar módulos após salvar
              this.loadModules();
            } else {
              this.setState({
                error: `Erro ao salvar ${failed_updates} de ${total_processed} permissões`,
                saving: false,
              });
            }
          } else {
            this.setState({
              error: resp.message || "Erro ao salvar configurações",
              saving: false,
            });
          }
        } catch (err) {
          this.setState({
            error: "Erro ao processar resposta do servidor",
            saving: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          error: "Erro ao conectar com o servidor",
          saving: false,
        });
      });
  };

  render() {
    const { modules, loading, saving, success, error } = this.state;

    if (loading && modules.length === 0) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "400px" }}
        >
          <div className="text-center">
            <CircularProgress color="primary" />
          </div>
        </div>
      );
    }

    return (
      <div className="configuracoes-container" style={{ padding: "20px" }}>
        <div className="card">
          <div className="card-header d-flex align-items-center">
            <MdSettings className="me-2" />
            <h5 className="mb-0">Configurações da Instituição</h5>
          </div>
          <div className="card-body">
            {error && (
              <div className="d-flex justify-content-center mb-4">
                <Alert
                  variant="danger"
                  dismissible
                  onClose={() => this.setState({ error: "" })}
                  className="w-100 text-center"
                >
                  <strong>Erro:</strong> {error}
                </Alert>
              </div>
            )}
            {success && (
              <div className="d-flex justify-content-center mb-4">
                <Alert
                  variant="success"
                  dismissible
                  onClose={() => this.setState({ success: false })}
                  className="w-100 text-center"
                >
                  <strong>Sucesso:</strong> Configurações salvas com sucesso!
                </Alert>
              </div>
            )}
            {/* Seção de Módulos e Features */}
            <div className="card mb-4">
              <div className="card-header">
                <h6 className="mb-0">Ativação de Módulos e Funcionalidades</h6>
              </div>
              <div className="card-body">
                {modules.length === 0 ? (
                  <div className="text-center py-4">
                    <MdSettings size={48} className="text-muted mb-3" />
                    <p className="text-muted">
                      Nenhum módulo disponível para configuração.
                    </p>
                  </div>
                ) : (
                  modules.map((module) => (
                    <div key={module.id} className="mb-4">
                      <div className="d-flex align-items-center justify-content-between mb-3 p-3 bg-light rounded">
                        <div className="d-flex align-items-center">
                          <MdSettings className="me-2 text-primary" />
                          <div>
                            <h6 className="mb-0">{module.label}</h6>
                            <small className="text-muted">
                              {module.description}
                            </small>
                          </div>
                        </div>                        <Form.Check
                          type="switch"
                          id={`module-${module.id}`}
                          checked={module.permissionEnabled}
                          onChange={(e) =>
                            this.handleModuleToggle(module.id, e.target.checked)
                          }
                          disabled={saving}
                          size="lg"
                        />
                      </div>                      
                      {module.permissionEnabled &&
                        module.features &&
                        module.features.length > 0 && (
                          <div className="ms-4">
                            <h6 className="text-muted mb-3">
                              O canditado terá acesso às seguintes funcionalidades:
                            </h6>
                            {module.features.map((feature) => (
                              <div key={feature.id} className="mb-3">
                                <div className="d-flex align-items-center justify-content-between p-2 border rounded">
                                  <div className="d-flex align-items-center">
                                    <span
                                      style={{ color: feature.color }}
                                      className="me-2"
                                    >
                                      {this.getIconComponent(feature.icon)}
                                    </span>
                                    <span>{feature.label}</span>
                                  </div>{" "}
                                  <Form.Check
                                    type="switch"
                                    id={`feature-${feature.id}`}
                                    checked={feature.permissionEnabled}
                                    onChange={(e) =>
                                      this.handleFeatureToggle(
                                        module.id,
                                        feature.id,
                                        e.target.checked
                                      )
                                    }
                                    disabled={saving}
                                  />
                                </div>

                                {feature.permissionEnabled &&
                                  feature.subFeatures &&
                                  feature.subFeatures.length > 0 && (
                                    <div className="ms-4 mt-2">
                                      {feature.subFeatures.map((subFeature) => (
                                        <div
                                          key={subFeature.id}
                                          className="d-flex align-items-center justify-content-between p-2 mb-1 bg-light rounded"
                                        >
                                          <div className="d-flex align-items-center">
                                            <span
                                              style={{
                                                color: subFeature.color,
                                              }}
                                              className="me-2"
                                            >
                                              {this.getIconComponent(
                                                subFeature.icon
                                              )}
                                            </span>
                                            <small>{subFeature.label}</small>
                                          </div>{" "}
                                          <Form.Check
                                            type="switch"
                                            id={`subfeature-${subFeature.id}`}
                                            checked={
                                              subFeature.permissionEnabled
                                            }
                                            onChange={(e) =>
                                              this.handleSubFeatureToggle(
                                                module.id,
                                                feature.id,
                                                subFeature.id,
                                                e.target.checked
                                              )
                                            }
                                            disabled={saving}
                                            size="sm"
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  )}
                              </div>
                            ))}
                          </div>
                        )}
                    </div>
                  ))
                )}
              </div>
            </div>{" "}
            <div className="d-flex justify-content-end">
              <Button
                variant="primary"
                onClick={this.salvarConfiguracoes}
                disabled={saving}
                className="d-flex align-items-center"
              >
                {saving ? (
                  <>
                    <CircularProgress
                      size={16}
                      color="inherit"
                      className="me-2"
                    />
                    Salvando...
                  </>
                ) : (
                  <>
                    <MdSave className="me-2" />
                    Salvar Configurações
                  </>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
    token: state.AppReducer.token,
    user: state.AppReducer.user,
});

export default connect(mapStateToProps, { logout })(FaculdadeConfiguracoes);
